module.exports = __webpack_public_path__ + "img/home-07-cosmopolitan-sample-04-food-03.ecd4c833.jpg";